export const BAD_REQUEST = { errorMessage: "Bad request", errorCode: 400 };
export const UNAUTHORIZED = { errorMessage: "Unauthorized", errorCode: 401 };
export const FORBIDDEN = { errorMessage: "Forbidden", errorCode: 403 };
export const SERVER_ERROR = { errorMessage: "Server Error", errorCode: 500 };
export const UNDEFINED_ERROR = { errorMessage: "Undefined Error", errorCode: -1 };